module.exports = "//public.getcloudapp.com/packs/media/images/download_icon_windows-cd0beb06264bd57f8a8ed71a01d82c77.svg";